// eslint-disable-next-line max-len
import { llmTrackerCampaignsQueryClient } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/llm-tracker-service/llmTrackerCampaignsQueryClient";
import type { IAiTrackerCampaign } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import type { EPrimarySideBar3StateType } from "app/reducers/_reducers/PrimarySidebar3Reducer";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const isDescendantOf = (
    currentState: { name?: string; parent?: string },
    ancestorName: string | undefined,
): boolean => {
    if (!ancestorName) {
        return false;
    }
    let state = currentState;
    const visited = new Set<string>();
    while (state?.name) {
        if (state.name === ancestorName) {
            return true;
        }
        if (!state.parent || visited.has(state.name)) {
            return false;
        }
        visited.add(state.name);
        state = proNavigator.getState(state.parent);
    }
    return false;
};

export const withCampaignAwareNavigation = (
    state: EPrimarySideBar3StateType,
    onCampaignFound: (campaign: IAiTrackerCampaign) => void,
): boolean => {
    const sectionRoot = proNavigator.getState(state)?.parent;
    const isAlreadyInSection = isDescendantOf(proNavigator.current(), sectionRoot);

    if (isAlreadyInSection) {
        return false;
    }

    const rawCampaignId = proNavigator.getParams()?.campaignId;
    const campaignId = typeof rawCampaignId === "string" ? rawCampaignId : undefined;
    if (!campaignId) {
        return false;
    }

    const campaign = llmTrackerCampaignsQueryClient.getCampaignsFromCache()?.find((c) => c.id === campaignId);
    if (!campaign) {
        return false;
    }

    onCampaignFound(campaign);
    return true;
};
